/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaToggleText/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaToggleText({
  children,
  viewPath = "/DesignSystem/TysiaToggle/TysiaToggleText",
  marginLeft,
  size = "xmedium",
  weight = "light",
  text = "Default text",
  whiteSpace,
  color
  
}) {
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={marginLeft || dtSpaceXxxs}
 size={size}
 weight={weight}
 text={text}
 whiteSpace={whiteSpace}
 color={color}
/>
{children}
</React.Fragment>)
}